import { render, staticRenderFns } from "./AppModalLoader.vue?vue&type=template&id=8dd19ac2"
import script from "./AppModalLoader.vue?vue&type=script&lang=js"
export * from "./AppModalLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports